import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import Menu from "./Menu";

const AboutUs: React.FC = () => {
  const contentContainerRef = useRef<HTMLDivElement | null>(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentContainerRef.current) {
        const contentRect = contentContainerRef.current.getBoundingClientRect();
        setIsSticky(contentRect.top <= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div ref={contentContainerRef}>
      {/* Static Banner Section */}
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          position: "relative",
          overflow: "hidden",
          background: `
            linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7)), 
            url(${"/assets/service_01.jpg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Menu isSticky={isSticky} />
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
            textAlign: "center",
          }}
        >
          <Typography variant="h3" fontWeight="bold" letterSpacing={1}>
            About Us
          </Typography>
        </Box>
      </Box>

      {/* About Us Content */}
      <Box sx={{ padding: "40px", backgroundColor: "#f9f9f9", color: "#000" }}>
        {/* Welcome Section */}
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          gutterBottom
          sx={{ fontSize: { xs: "28px", md: "36px" }, mb: 4 }}
        >
          Welcome to GetMyShares
        </Typography>

        <Typography variant="body1" paragraph>
          At <strong>GetMyShares</strong>, we simplify the journey of reclaiming your rightful shares and investments. Whether you've lost track of old stock holdings, need help recovering unclaimed dividends, are facing challenges after the original shareholder has passed away, or require expert guidance on dematerialising physical share certificates — we are here to assist you every step of the way.
        </Typography>

        <Typography variant="body1" paragraph>
          With deep expertise in investment recovery and financial regulations, <strong>GetMyShares</strong> is committed to making the process seamless, transparent, and efficient. Our team works diligently to help individuals and entities regain control over their lost or unclaimed assets, ensuring that what is rightfully yours is returned.
        </Typography>

        <Typography variant="body1" paragraph>
          We proudly offer our services across <strong>PAN India</strong> and assist <strong>NRI clients</strong> globally in reclaiming their investments.
        </Typography>

        {/* Highlight CS Priya Aggarwal */}
        <Box
          sx={{
            backgroundColor: "#e0f2f1",
            padding: "40px",
            borderRadius: "12px",
            marginTop: "50px",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              color: "#00695c",
              marginBottom: "20px",
              fontSize: { xs: "28px", md: "36px" },
            }}
          >
            Meet Our Founder - CS Priya Aggarwal
          </Typography>

          <Typography variant="body1" paragraph sx={{ fontSize: "18px", color: "#333" }}>
            <strong>CS Priya Aggarwal</strong> — the visionary Founder of GetMyShares — is a seasoned Company Secretary with extensive expertise in financial recovery and investor rights. With a profound understanding of legal and regulatory frameworks, she has successfully assisted individuals — including NRIs — in reclaiming lost, unclaimed, or misplaced shares with remarkable efficiency.
          </Typography>

          <Typography variant="body1" paragraph sx={{ fontSize: "18px", color: "#333" }}>
            Priya’s dedication to her clients goes beyond professional expertise. She offers transparent, ethical, and personalized solutions to investors, ensuring each case is handled with care and precision. Her ability to resolve share-related disputes and navigate financial complexities has earned her widespread recognition.
          </Typography>

          <Typography variant="body1" paragraph sx={{ fontSize: "18px", color: "#333" }}>
            With a relentless pursuit of excellence, <strong>CS Priya Aggarwal</strong> continues to lead <strong>GetMyShares</strong> with integrity, making financial recovery seamless for countless investors.
          </Typography>
        </Box>

        {/* Meet Our Team Section */}
        <Typography
          variant="h5"
          fontWeight="bold"
          sx={{ marginTop: "60px", marginBottom: "20px", fontSize: { xs: "24px", md: "28px" }, color: "#333" }}
        >
          Our Team
        </Typography>

        <Typography variant="body1" paragraph>
          At the heart of <strong>GetMyShares</strong> is a passionate team of experienced Company Secretaries and Chartered Accountants specializing in compliance, regulatory frameworks, and financial recovery. Their expertise ensures that every case is handled with precision and professionalism, providing investors with a structured and legally sound approach to reclaiming their assets.
        </Typography>

        <Typography variant="body1" paragraph>
          We are committed to ethical practices, client-centric solutions, and safeguarding your interests, ensuring a smooth and successful recovery journey.
        </Typography>
      </Box>
    </div>
  );
};

export default AboutUs;
